/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Badge,
} from "reactstrap";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//i18n
import { withTranslation } from "react-i18next";

import {
  isArray,
  objLength,
} from "../../../../Libs/CustomMethods/customMethods";

// actions
import {
  setFlashMsgs,
  createFlashMsg,
  editFlashMsg,
  resetFlashMsg,
  resetError,
  deleteFlashMsg,
} from "../../../../store/flashmessage/actions";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const FlashMsg = ({
  isFlashEditCreate,
  toggleFlashEditCreate,
  isFlashDelete,
  toggleFlashDelete,
  objFlashMsg,
  t,
}) => {
  const dispatch = useDispatch();
  const {
    dataFlashMsg,
    dataFlashMsgEditCreate,
    loadingFlashMsgEditCreate,
    dataFlashMsgDelete,
    loadingFlashMsgDelete,
    successFlashMsg,
    errorFlashMsg,
  } = useSelector((state) => state.FlashMsgs);

  const [flashMsgValues, setFlashMsgValues] = useState({
    short_name: "",
    message: "",
  });

  const maxMessage = 1500;

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const handleCreateEditFlashMsg = () => {
    if (objFlashMsg?.id) {
      dispatch(editFlashMsg(objFlashMsg.id, newFields));
    } else {
      dispatch(createFlashMsg(newFields));
    }
  };

  const handleDeleteFlahsMsg = (flashMsgId) => {
    dispatch(deleteFlashMsg(flashMsgId));
  };

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      onHidden: () => {
        dispatch(resetFlashMsg());
        if (successFlashMsg) {
          isFlashEditCreate && toggleFlashEditCreate();
          isFlashDelete && toggleFlashDelete();
        }
      },
    };
    toastr[type](message);
  };

  const handleChangeField = useCallback(
    (value, field) => {
      if (value === flashMsgValues[field]) {
        delete newFields?.[field];
        checkSubmit();
      } else {
        setNewFields((previous) => ({
          ...previous,
          [field]: value,
        }));
      }
    },
    [flashMsgValues]
  );

  const checkSubmit = () => {
    setEnableSubmit(!!objLength(newFields));
  };

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  useEffect(() => {
    setNewFields({});
    setFlashMsgValues((previous) => ({
      ...previous,
      short_name: objFlashMsg?.short_name ?? "",
      message: objFlashMsg?.message ?? "",
    }));
  }, [objFlashMsg]);

  useEffect(() => {
    if (dataFlashMsgEditCreate?.message) {
      showToast("success", t(dataFlashMsgEditCreate?.message));
      if (objFlashMsg?.id) {
        //EDIT FLASH MESSAGE
        let aux = dataFlashMsg.responseFlash.map((e) =>
          e.id === objFlashMsg.id ? { ...objFlashMsg, ...newFields } : e
        );
        dispatch(setFlashMsgs({ ...dataFlashMsg, responseFlash: aux }));
      } else {
        //CREATE FLASH MESSAGE
        let aux = dataFlashMsg.responseFlash;
        aux.push({
          ...newFields,
          ...dataFlashMsgEditCreate?.data,
        });
        dispatch(setFlashMsgs({ ...dataFlashMsg, responseFlash: aux }));
      }
    }
    if (dataFlashMsgDelete?.message) {
      showToast("success", t(dataFlashMsgDelete.message));
      if (objFlashMsg?.id) {
        //EDIT FLASH MESSAGE
        let aux = dataFlashMsg.responseFlash.filter(
          (e) => e.id !== objFlashMsg.id
        );
        dispatch(setFlashMsgs({ ...dataFlashMsg, responseFlash: aux }));
      }
    }
  }, [successFlashMsg]);

  useEffect(() => {
    if (errorFlashMsg) {
      if (isArray(errorFlashMsg)) {
        errorFlashMsg.map((error) => showToast("error", t(error.value)));
      } else {
        if (errorFlashMsg) {
          showToast("error", t(errorFlashMsg));
        }
      }
      dispatch(resetError());
    }
  }, [errorFlashMsg]);

  return (
    <div>
      <AvForm onValidSubmit={handleCreateEditFlashMsg}>
        <Modal isOpen={isFlashEditCreate} toggle={toggleFlashEditCreate}>
          <ModalHeader>Flash Message</ModalHeader>
          <ModalBody className="p-0">
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <Row className="mb-3">
                      <Col xs="12">
                        <FormGroup>
                          <AvField
                            label={t("Name") + " *"}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Enter name")}
                            value={flashMsgValues?.short_name ?? ""}
                            onChange={(e) =>
                              handleChangeField(e.target.value, "short_name")
                            }
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 45,
                                errorMessage: t("Invalid field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t(
                                  "Name must be at least 3 characters long"
                                ),
                              },
                            }}
                            autoComplete="off"
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12">
                        <FormGroup>
                          <AvField
                            label={t("Message") + " *"}
                            id="message"
                            name="message"
                            type="textarea"
                            className="form-control"
                            placeholder={t("Enter a message")}
                            value={flashMsgValues?.message ?? ""}
                            onChange={(e) =>
                              handleChangeField(e.target.value, "message")
                            }
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: maxMessage,
                                errorMessage: t("Invalid field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t(
                                  "Description must be at least 3 characters long"
                                ),
                              },
                            }}
                            autoComplete="off"
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <div className="d-flex w-100 justify-content-end">
                          {newFields?.message && (
                            <Badge
                              className="my-2"
                              color={`${
                                newFields?.message?.length < maxMessage
                                  ? "primary"
                                  : "danger"
                              }  ml-3 mb-1`}
                            >
                              {maxMessage - (newFields?.message?.length ?? 0)}
                            </Badge>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              className="waves-effect btn-dark"
              onClick={() => toggleFlashEditCreate()}
            >
              {t("Cancel")}
            </Button>
            <Button
              type="submit"
              color="primary"
              className="mr-1 waves-effect waves-light"
              style={{
                minWidth: "100px",
                cursor: enableSubmit ? "pointer" : "no-drop",
              }}
              onClick={handleCreateEditFlashMsg}
              disabled={!enableSubmit}
            >
              {loadingFlashMsgEditCreate ? (
                <Spinner
                  size="sm"
                  animation="border"
                  style={{
                    height: "19px",
                    width: "19px",
                  }}
                />
              ) : (
                t("Confirm")
              )}
            </Button>
          </ModalFooter>
        </Modal>
      </AvForm>
      <Modal isOpen={isFlashDelete}>
        <div className="modal-body font-size-18 text-center">
          {t("Do you want to delete this Flash Message")}
          <strong> {objFlashMsg?.short_name}</strong>?
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-danger waves-effect"
            data-dismiss="modal"
            style={{ backgroundColor: "#f14646" }}
            onClick={() => toggleFlashDelete()}
          >
            {t("No")}
          </button>
          {loadingFlashMsgDelete ? (
            <button
              className="btn btn-secondary waves-effect waves-light"
              disabled
            >
              <Spinner size="sm" animation="border" />
            </button>
          ) : (
            <button
              className="btn btn-secondary waves-effect waves-light"
              onClick={() => handleDeleteFlahsMsg(objFlashMsg?.id)}
            >
              {t("Yes")}
            </button>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default withTranslation()(FlashMsg);
